const state = {
  config: {},
  device: 'mobile'
}

const mutations = {
  INIT_ENV: (state, device) => {
    state.device = device
  }
}

const actions = {
  initEnv({ commit }, device) {
    commit('INIT_ENV', device)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js